exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#login[data-v-66ed9fa3] {\n    margin-top: 32px;\n    text-align: center;\n.logo[data-v-66ed9fa3] {\n        width: 64px;\n        height: 64px;\n}\n}\n", ""]);

// exports
